import {
  Grid,
  withStyles,
  WithStyles,
  Paper,
  Theme,
  Typography
} from '@material-ui/core'
import i18n from 'i18next'
import { Fragment } from 'react'
import {
  DenyReservableAction,
  ReserveShowingAction,
  OpenDialog
} from '../../../actions/types'
import { Message } from '../../../components/Messages'
import { ApplicationStatus } from '../../../types/applications'
import { ReserveData } from '../../../types/showings'
import { ReserveInterface } from '../../../types/states'
import Suggest from '../../Apartment/Stepper/Steps/Suggest'
import ReservedCard from './InfoViews/ReservedCard'
import { SuggestReservableCard } from './SuggestReservableCard'
import ReservableCard from './SuggestReservableCard/ReservableCard'
import { UpdateStatusDialog } from './UpdateStatus'

const styles = ({ breakpoints }: Theme) => ({
  mainContainer: {
    maxWidth: '1151px',
    paddingTop: '35px'
  },
  /** LandlordIdentifier-like card wrapper (wantsContract only) */
  landlordBox: {
    margin: '3rem auto',
    justifyItems: 'center',
    padding: '2rem',
    border: '1px solid #ddd',
    borderRadius: '10px',
    backgroundColor: '#fff',
    maxWidth: '70%',
    [breakpoints.down('sm')]: {
      maxWidth: '70%'
    }
  },
  /** Text styles adapted from LandlordIdentifier */
  landlordDescription: {
    marginBottom: '1.5rem',
    lineHeight: 1.6,
    textAlign: 'center' as const,
    display: 'flex',
    justifyContent: 'center'
  },
  notInterestedGrid: {
    margin: '1rem auto',
    width: '100%'
  },
  notInterestedButton: {
    margin: '0 auto 1rem 0',
    borderRadius: '10px',
    fontFamily: 'CircularBold',
    background: '#fff',
    color: '#D43838',
    textDecoration: 'underline' as const,
    padding: '0.5rem 1.5rem',
    whiteSpace: 'nowrap' as const,
    boxShadow: 'none',
    '&:hover': {
      background: '#fff',
      color: '#D43838',
      boxShadow: 'none'
    }
  },
  noAvailableTimesGrid: {
    margin: ' auto',
    marginTop: '1rem',
    background: '#ffffff !important'
  },
  noReservables: {
    padding: '20px',
    [breakpoints.down(1180)]: {
      marginLeft: '20px',
      marginRight: '25px',
    },
  },
  cardWrapper: {
    display: 'flex',
    padding: '0',
    margin: 'auto',
    maxWidth: '480px',
    '& .MuiCardContent-root': {
      width: '100%'
    }
  },
  cardContainer: {
    maxWidth: '450px',
    padding: '8px 16px',
    width: '100%',
    [breakpoints.down('sm')]: {
      margin: '0 auto'
    }
  },
  card: {
    maxWidth: '450px',
    padding: '8px',
    width: '100%',
    borderRadius: '4px',
    [breakpoints.down('sm')]: {
      width: '95%',
      margin: '0 auto'
    }
  },
  cardInfo: {
    padding: '8px',
    width: '96%',
    borderRadius: '0',
    border: '1px solid #A0A0A0',
    boxShadow: 'none',
    [breakpoints.down('sm')]: {
      width: '94%',
      margin: '0 auto'
    }
  },
  cardActions: {
    justifyContent: 'space-between',
    marginBottom: '0.5rem',
    marginTop: '1.5rem',
    padding: '0px'
  },
  recommended: {
    color: 'green',
    display: 'flex',
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    marginTop: '0.5rem'
  },
  checkIcon: {
    marginRight: '5px'
  },
  titleContainer: {
    textAlign: 'center' as const,
    margin: '1rem',
    marginTop: '2.5rem'
  },
  helperContainer: {
    textAlign: 'center' as const,
    margin: '1rem'
  },
  titleReserveCard: {
    fontFamily: 'CircularBold',
    fontSize: '1.5rem',
    [breakpoints.down('sm')]: {
      fontSize: '1.2rem'
    }
  },
  statusUpdate: {
    textAlign: 'center' as const,
    marginTop: '2.5rem'
  },
  noAvailableTimesButton: {
    background: '#fff',
    border: '1px solid #717171',
    boxShadow: 'none'
  },
  buttonContainer: {
    margin: 'auto',
    maxWidth: '450px',
    padding: '8px 16px'
  },
  modalContainer: {
    padding: '24px',
    [breakpoints.down('sm')]: {
      padding: '0'
    }
  },
  modalItem: {
    fontSize: '1.3rem',
    marginBottom: '15px',
    [breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  primaryBtn: {
    backgroundColor: '#94004A',
    width: '100%',
    padding: '15px 0',
    borderRadius: '10px',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  datePicker: {
    position: 'relative' as const,
    width: '100%',
    textAlign: 'left' as const,
    '& > label': {
      fontFamily: 'CircularRegular',
      display: 'inline-block',
      paddingBottom: '0.5rem'
    },
    '& .MuiInput-underline': {
      margin: '0',
      '&::after': {
        content: 'none !important'
      },
      '&::before': {
        content: 'none !important'
      }
    },
    '& > svg': {
      display: 'inline-block',
      height: '1rem',
      width: '1rem',
      content: '""',
      background: 'transparent',
      color: 'gray',
      position: 'absolute' as const,
      top: '35%',
      left: '10px',
      zIndex: '15',
      cursor: 'pointer',
      pointerEvents: 'none'
    },
    '& > .MuiTypography-root': {
      color: '#A9B0B5',
      background: '#E7ECEF',
      fontSize: '1.1rem',
      cursor: 'pointer',
      zIndex: '10',
      padding: '12px 21px 10px 35px',
      borderRadius: '6px',
      border: 'none',
      '&::after': {
        content: 'none !important'
      }
    }
  },
  largeForm: {
    [breakpoints.up('sm')]: {
      paddingTop: '16px'
    },
    [breakpoints.down('sm')]: {
      padding: '16px'
    }
  }
})

interface ReserveViewInterface extends WithStyles {
  t: i18n.TFunction
  reserve: ReserveInterface
  reserveData: ReserveData
  reserveShowing: ReserveShowingAction
  denyReservable: DenyReservableAction
  openDialog: OpenDialog
}

/** Reserve suggest logic
 *
 * Motivation for logic:
 * Prevent landlords from having to go to single showings every day/scattered around.
 *
 * Functionality explained:
 *
 * Applicant is suggested best times as cards with "Yes" or "No" options,
 * if they choose no they are suggested "best" reservables until there are none.
 *
 * When there are no best reservables,
 * the applicant is shown reservables as single cards from first to last
 *
 * Logic order
 *
 * -Start of Card view/single suggestion-
 * 1. Suggest a reservable showing (either bestReservable, or reservable)
 *
 * BestReservable types:
 * openHouse bestReservable = openHouse with applicationIds
 * personal bestReservable = personal showings 30min before or after showing
 *
 * a. openHouse suggests exact time
 * b. If personal flag as best reservables before and after
 *
 *
 * 3. User is shown individual showing and asked if they want to reserve it
 *  a. The user can click yes and reserve (add applicationId to showing.applicationIds) PROCESS FINISHED
 *  b. The user can click no
 *
 * 4. Suggest next
 *
 * b. If difference between reservables is less than duration on SAME day,
 * go to next day. Repeat 3x then go to table view.
 *
 * When no showings left, cycle showings from start
 *
 * -End of card view-
 *
 */
const ReserveView = ({
  t,
  reserveData,
  reserveData: { apartment, reserved },
  reserveShowing,
  openDialog,
  classes
}: ReserveViewInterface) => {
  //const hasReservables = reservableAmount + bestReservableAmount !== 0
  const reservableCardProps = {
    classes,
    t,
    openDialog
  }
  const hasReservables = reserveData.invited?.length !== 0

  const hasCustomStatus =
    reserveData.application?.status === 'noAvailableTimes' ||
    reserveData?.application?.status === 'notInterested'
  const applicationStatus = hasCustomStatus
    ? reserveData?.application?.status
    : undefined
  const isWantsContract = reserveData?.application?.status === ApplicationStatus.wantsContract
  return (
    <Grid container justify='center'>
      <Grid container justify='center' className={classes.mainContainer}>
        {hasCustomStatus && applicationStatus && (
          <Typography
            variant='h6'
            gutterBottom
            style={{ textAlign: 'center', margin: '2.5rem 2rem 1rem 2rem' }}
          >
            {t(`showings.reserve.updateStatus.${applicationStatus}.success`)}
          </Typography>
        )}
        <Grid item xs={12} sm={isWantsContract ? 12 : 6}>
          <div className={isWantsContract ? classes.landlordBox : undefined}>
          {hasReservables && !reserved ? (
            <Fragment>
              <Grid item sm={12} className={classes.helperContainer}>
                <Typography
                  variant='h5'
                  className={`${classes.titleReserveCard} ${isWantsContract ? classes.landlordHeader : ''}`}
                >
                  {t(`showings.reserve.reserveCardTitle`)}
                </Typography>
              </Grid>
              <SuggestReservableCard
                invitedShowings={reserveData.invited}
                classes={classes}
                t={t}
                reserveShowing={reserveShowing}
                openDialog={openDialog}
                reserveData={reserveData}
              />
              <Grid container className={classes.buttonContainer}>
                {applicationStatus !== ApplicationStatus.notInterested &&
                  applicationStatus !== ApplicationStatus.showingReserved && (
                    <Fragment>
                      <ReservableCard {...reservableCardProps} />
                      <Grid
                        item
                        xs={11}
                        md={12}
                        className={classes.notInterestedGrid}
                      >
                        <UpdateStatusDialog
                          status={ApplicationStatus.notInterested}
                          noReservablesCase={false}
                          buttonClassName={classes.notInterestedButton}
                          t={t}
                        />
                      </Grid>
                    </Fragment>
                  )}
              </Grid>
            </Fragment>
          ) : reserved ? (
            <div>
              <ReservedCard
                classes={classes}
                reserveData={reserveData}
                reserved={reserved}
                address={apartment?.addressFull}
                t={t}
              />
              {/* HERE */}
              <Grid
                container
                className={classes.buttonContainer}
                style={{ maxWidth: '450px' }}
              >
                {applicationStatus !== ApplicationStatus.notInterested &&
                  applicationStatus !== ApplicationStatus.showingReserved && (
                    <Fragment>
                      {/* No available times, suggest own */}
                      {!reserved && (
                        <Grid
                          item
                          xs={11}
                          md={12}
                          className={classes.noAvailableTimesGrid}
                        >
                          <UpdateStatusDialog
                            status={ApplicationStatus.noAvailableTimes}
                            noReservablesCase={false}
                            t={t}
                            buttonClassName={classes.noAvailableTimesButton}
                          />
                        </Grid>
                      )}
                      {/* No interested anymore */}
                      <Grid
                        item
                        xs={11}
                        md={12}
                        className={classes.notInterestedGrid}
                      >
                        <UpdateStatusDialog
                          status={ApplicationStatus.notInterested}
                          noReservablesCase={false}
                          t={t}
                          buttonClassName={classes.notInterestedButton}
                        />
                      </Grid>
                    </Fragment>
                  )}
              </Grid>
            </div>
          ) : (
            <>
              <Paper
                className={classes.noReservables}
                elevation={isWantsContract ? 0 : undefined}
                style={
                  isWantsContract
                    ? { padding: 0, marginLeft: 0, marginRight: 0 }
                    : undefined
                }
              >
                <div className={isWantsContract ? classes.landlordDescription : undefined}>
                  <Message
                    variant={isWantsContract ? 'body1' : undefined}
                    message={
                      applicationStatus === ApplicationStatus.noAvailableTimes
                        ? t(
                            'showings.reserve.noReservables.messageNoAvailableTimes'
                          )
                        : t('showings.reserve.noReservables.message')
                    }
                  />
                </div>
              </Paper>
              {reserveData?.application?.status ===
                ApplicationStatus.wantsContract && (
                <Grid
                  container
                  className={classes.buttonContainer}
                  style={{ maxWidth: '450px' }}
                >
                  <Grid
                    item
                    xs={11}
                    md={12}
                    className={classes.notInterestedGrid}
                  >
                    <UpdateStatusDialog
                      status={ApplicationStatus.notInterested}
                      noReservablesCase={false}
                      t={t}
                      buttonClassName={classes.notInterestedButton}
                    />
                  </Grid>
                </Grid>
              )}
            </>
          )}
          </div>
        </Grid>
        {!isWantsContract && (
          <Grid sm={6} xs={12}>
            <Suggest desktopMaxWidth="450px"
              containerMaxWidth='450px'
              contentMaxWidth='450px'
              content={
                reserved
                  ? t('showings.hints.confirmedReservation')
                  : t('showings.hints.reserveHint')
              }
              classes={classes}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(ReserveView)
